import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SimpleViewCommissioningRoutingModule } from './simple-view-commissioning-routing.module';
import { SimpleViewCommissioningComponent } from './simple-view-commissioning.component';
import { MdbGlobalModule } from 'src/app/shared/mdb-global.module';
@NgModule({
  declarations: [
    SimpleViewCommissioningComponent
  ],
  imports: [
    CommonModule,
    SimpleViewCommissioningRoutingModule, 
    MdbGlobalModule
  ]
})
export class SimpleViewCommissioningModule { }
